module.exports = __webpack_public_path__ + "static/media/1.554703b4.jpg";